/**
 * DevExtreme (esm/renovation/ui/editors/common/editor_state_props.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import devices from "../../../../core/devices";
export var EditorStateProps = {
    hoverStateEnabled: true,
    activeStateEnabled: true,
    get focusStateEnabled() {
        return "desktop" === devices.real().deviceType && !devices.isSimulator()
    }
};
